import { render, staticRenderFns } from "./ManagementApproval.vue?vue&type=template&id=f99b4670"
import script from "./ManagementApproval.vue?vue&type=script&lang=js"
export * from "./ManagementApproval.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports